import { Routes, Route } from "react-router-dom";

import Admin from "./pages/Admin/Admin";

import User from "./pages/user/User";

import { AppProvider } from "../context/Context";

import "bulma/css/bulma.min.css";
import AdminLogin from "./pages/Admin/AdminLogin";

export default function App() {
    return (
        <AppProvider>
            <Routes>
                <Route path="/*" element={<User />} />
                <Route path="/admin/*" element={<Admin />} />
                <Route path="/login" element={<AdminLogin />} />
            </Routes>
        </AppProvider>
    );
}
